/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useState } from 'react'
import { Field, Form, Formik } from 'formik'
import styled from 'styled-components'
import * as Yup from 'yup'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Button, Form as NXUIForm } from '@nexigendigital/nxui'
import { assignHostingName, resetHostingName } from 'store/slices/shopSlice'
import { ProductServiceType } from 'models/enums'
import { regex } from 'helpers/utils'
import { PendingItem } from 'models/shop'
import { useAppDispatch, useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Existing() {
    const dispatch = useAppDispatch()
    const { items } = useAppSelector((state) => state.shop)
    const lastWebHosting: any = items.find((item: PendingItem) => item.product_type === ProductServiceType.SharedHosting)
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        setDisabled(!!lastWebHosting.name)
    }, [lastWebHosting.name])

    return (
        <Formik
            initialValues={{
                domain: lastWebHosting.name || ''
            }}
            validationSchema={Yup.object({
                domain: Yup.string()
                    .matches(regex.domainWithExtension, 'Domain Name is not valid')
            })}
            onSubmit={({ domain }, { setSubmitting }) => {
                if (lastWebHosting.name) {
                    dispatch(resetHostingName())
                } else {
                    dispatch(assignHostingName({ name: domain }))
                }
                setSubmitting(false)
            }}
        >
            {() => (
                <StyledExisting>
                    <Form>
                        <Field
                            label={'Domain'}
                            name={'domain'}
                            type={'text'}
                            prefixes={['www']}
                            disabled={disabled}
                            component={NXUIForm.InputField}
                        />
                        {lastWebHosting.name
                            ? <Button type={'submit'} color={'primary'}>Change</Button>
                            : <Button type={'submit'} color={'primary'}>Assign</Button>
                        }
                    </Form>
                </StyledExisting>
            )}
        </Formik>
    )
}

/**********************************************************************************************************
 *   COMPONENT PROPTYPES
 **********************************************************************************************************/
Existing.propTypes = {}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledExisting = styled.section`
    width: 100%;
    padding: 10px 20px;

    > form {
        display: flex;
        align-items: center;

        > div {
            width: 100%;
        }
    }
`
